export const BROADCAST_CHANNEL_EVENTS = {
  CLOSE_FCT: 'CLOSE_FCT',
} as const;

type BroadcastChannelEventType = keyof typeof BROADCAST_CHANNEL_EVENTS;

export type WindowOpenFunction = (...args: Parameters<typeof globalThis.open>) => null | Window;

export interface FctBroadcastChannelMessage {
  studyId: string;
  type: BroadcastChannelEventType;
}

export interface BroadcastChannelState {
  onOpenTrackedWindow: WindowOpenFunction;
}
